import React, {useEffect, useMemo, useRef, useState} from 'react'
import Select, { SingleValue } from 'react-select'
import { Link } from 'react-router-dom'
import Producent from '../../../model/producent'
import Producentarendetyp from '../../../model/producentarendetyp'

// OBS: Här ställs det in att vi går mot statiska sidor. Om man istället vill gå mot GraphQl (som inte fungerar för tillfället), ändra här till graphql-varianterna
import * as ProducentService from '../../../service/static/producentServiceStatic'
import * as ProducentarendetypService from '../../../service/static/producentarendetypServiceStatic'

import {useFilters, useTable} from 'react-table'
import MyReactTable from '../../components/myReactTable'

import './searchPage.scss'


interface ProducentOption {
    value: Producent,
    label: String
}

interface ProducentarendetypNamnOption {
    value: string,
    label: string
}

const SearchPage = () => {
    const [selectedProducentOption, setSelectedProducentOption] = useState<ProducentOption>()
    const [selectedProducentarendetypNamn, setSelectedProducentarendetypNamn] = useState<ProducentarendetypNamnOption>()

    const producenterRef = useRef<Producent[]>([])
    const producentarendetyperRef = useRef<Producentarendetyp[]>([])

    const [producentOptions, setProducentOptions] = useState<ProducentOption[]>([])
    const [producentarendetypNamnOptions, setProducentarendetypNamnOptions] = useState<ProducentarendetypNamnOption[]>([])

    const tableData = useMemo(() => {
        return producentarendetyperRef.current.map((p: Producentarendetyp) => {
            return {
                producent: p.producent.namn,
                producentarendetypNamn: p.namn,
                producentId: p.producent.dbId,
                lastUpdated: (p.updatedAt ? p.updatedAt.toLocaleDateString("sv-SW") : ''),
                producentarendetypId: p.dbId
            }
        })}, [producentarendetyperRef.current])

    const columns = useMemo(() => [
        {
            Header: 'Producent',
            accessor: 'producent',
            Cell: (props: any) => {
                const producentId = props.row.original.producentId

                return (
                    <Link to={'/producent/' + producentId}>{props.cell.value}</Link>
                )
            }
        },
        {
            Header: 'Producentärendetyp',
            accessor: 'producentarendetypNamn',
            Cell: (props: any) => {
                const producentarendetypId: string = props.row.original.producentarendetypId
                return (
                    <Link to={'/producentarendetyp/' + producentarendetypId}>{props.cell.value}</Link>
                )
            }
        },
        {
            Header: 'Senast uppdaterad',
            accessor: 'lastUpdated',
        }
    ], [])
    const tableInstance = useTable({columns: columns, data: tableData}, useFilters)

    const fetchingProducenter = useRef<boolean>(false)
    const fetchingProducentarendetyper = useRef<boolean>(false)
    const fetchedProducenter = useRef<boolean>(false)
    const fetchedProducentarendetyper = useRef<boolean>(false)

    useEffect(() => {
        const fetchProducenter = async() => {
            fetchingProducenter.current = true

            producenterRef.current = await ProducentService.getAll()

            fetchingProducenter.current = false
            fetchedProducenter.current = true

            const options: ProducentOption[] = producenterRef.current.map((p) => {
                return {
                    label: p.namn,
                    value: p
                }
            }).sort((a: ProducentOption, b: ProducentOption) => {
                return a.label < b.label ? -1 : 1
            })
            setProducentOptions(options)
        }
        const fetchProducentarendetyper = async() => {
            fetchingProducentarendetyper.current = true

            producentarendetyperRef.current = await ProducentarendetypService.getAll()

            fetchingProducentarendetyper.current = false
            fetchedProducentarendetyper.current = true

            const options = producentarendetyperRef.current.map((p) => {
                return p.namn
            }).filter((value, index, self) => { // Ta fram unika. https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
                return self.indexOf(value) === index
            }).map((namn) => {
                return {
                    label: namn,
                    value: namn
                }
            }).sort((a: ProducentarendetypNamnOption, b: ProducentarendetypNamnOption) => {
                return a.label < b.label ? -1 : 1
            })

            setProducentarendetypNamnOptions(options)
        }
        if (!fetchingProducenter.current && !fetchedProducenter.current)    // OBS, useEffect blir anropad vid varje 'render cycle', vilket leder till massa anrop till db i onödan
            fetchProducenter()

        if (!fetchingProducentarendetyper.current && !fetchedProducentarendetyper.current)
            fetchProducentarendetyper()
    })

    const onChangeProducent = (option: SingleValue<ProducentOption> | undefined) => {
        const column = tableInstance.columns[0]
        if (option) {
            setSelectedProducentOption(option)
            column.setFilter(option.label)
        } else {
            setSelectedProducentOption(undefined)
            column.setFilter(undefined)
        }
    }

    const onChangeProducentarendetypNamn = (option: SingleValue<ProducentarendetypNamnOption> | undefined) => {
        const column = tableInstance.columns[1]
        if (option) {
            setSelectedProducentarendetypNamn(option)
            column.setFilter(option.label)
        } else {
            setSelectedProducentarendetypNamn(undefined)
            column.setFilter(undefined)
        }
    }

    return (
        <div className="container-fluid">
            <div id="search-selectors" className="row container-fluid">
                <div className="row">
                    <div className="col-md-6 heading">Producent</div>
                    <div className="col-md-6 heading">Producentärendetyp</div>
                </div>
                <div className="row">
                    <Select
                        options={producentOptions}
                        onChange={onChangeProducent}
                        value={selectedProducentOption}
                        isClearable={true}
                        isSearchable={true}
                        className="col-md-6"
                    />
                    <Select
                        options={producentarendetypNamnOptions}
                        onChange={onChangeProducentarendetypNamn}
                        value={selectedProducentarendetypNamn}
                        isClearable={true}
                        isSearchable={true}
                        className="col-md-6"
                    />
                </div>
            </div>
            <div id="search-results" className="row justify-content-center">
                <MyReactTable tableInstance={tableInstance} />
            </div>
        </div>
    )
}

export default SearchPage

